import axios from "@/plugins/axios";

const BASE_URL = '/concessionaire-users';

// ==========================================
// CRUD PRINCIPAL (Listar, Crear, Editar, Eliminar)
// ==========================================

export const fetchUsers = async ({
  page = 1,
  perPage = 10,
  search = '',
  orderByMethod = 'asc',
  status = null,
  filters = {},
} = {}) => {
  try {
    const params = { page, perPage, search, orderByMethod };
    if (status !== null && status !== undefined) params.status = status;
    if (Object.keys(filters).length > 0) params.filters = filters;

    const response = await axios.get(BASE_URL, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};

export const createUser = async (userData) => {
  try {
    const response = await axios.post(BASE_URL, userData);
    return response.data;
  } catch (error) {
    console.error('Error creating user:', error);
    throw error;
  }
};

export const updateUser = async (userId, userData) => {
  try {
    const response = await axios.put(`${BASE_URL}/${userId}`, userData);
    return response.data;
  } catch (error) {
    console.error(`Error updating user with ID ${userId}:`, error);
    throw error;
  }
};

export const deleteUser = async (userId) => {
  try {
    const response = await axios.delete(`${BASE_URL}/${userId}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting user with ID ${userId}:`, error);
    throw error;
  }
};

export const getUserById = async (userId) => {
  try {
    const response = await axios.get(`/concessionaire-users/${userId}`);
    return response.data.data || response.data; 
  } catch (error) {
    console.error(`Error fetching user ${userId}:`, error);
    throw error;
  }
};

export const exportUsers = async ({
  search = '',
  status = null,
  filters = {},
} = {}) => {
  try {
    const params = { search };
    if (status !== null && status !== undefined) params.status = status;
    if (Object.keys(filters).length > 0) params.filters = filters;

    const response = await axios.get(`${BASE_URL}/export-users`, {
      params,
      responseType: 'blob',
    });
    return response;
  } catch (error) {
    console.error("Error al exportar usuarios:", error);
    throw error;
  }
};

// ==========================================
// GESTIÓN DE VISTAS (Views)
// ==========================================

export async function fetchUserViews(userId) {
  try {
    const response = await axios.get(`${BASE_URL}/${userId}/views`);
    return response.data.data || [];
  } catch (error) {
    console.error("Error al obtener las vistas del usuario:", error);
    throw error;
  }
}

export async function syncUserViews(userId, views) {
  try {
    const response = await axios.post(`${BASE_URL}/${userId}/sync-views`, {
      views,
    });
    return response.data;
  } catch (error) {
    console.error("Error al sincronizar las vistas del usuario:", error);
    throw error;
  }
}

// ==========================================
// GESTIÓN DE ROLES (Roles)
// ==========================================

export async function fetchUserRoles(userId) {
  try {
    const response = await axios.get(`${BASE_URL}/${userId}/roles`);
    return response.data.data || [];
  } catch (error) {
    console.error("Error al obtener los roles del usuario:", error);
    throw error;
  }
}

export async function syncUserRoles(userId, roles) {
  try {
    const response = await axios.post(
      `${BASE_URL}/${userId}/sync-roles`,
      { roles }
    );
    return response.data;
  } catch (error) {
    console.error("Error al sincronizar roles del usuario:", error);
    throw error;
  }
}